export const reportDownloadSentStyleFunctiontyleOneReset = {
  ".downloadbox-section": {
    padding: "100px 0",
    "background-color": { r: 249, g: 249, b: 249, a: 100 },
  },
  ".downloadbox-section.bg-image": {},
  ".downloadbox-section.bg-image::before": {},
  ".downloadbox-section .section-title-area": {
    "margin-bottom": "50px",
  },
  ".downloadbox-section .section-title-area .section-subtitle": {
    "font-size": "16px",
    "font-weight": "600",
    color: { r: 255, g: 73, b: 124, a: 100 },
    "background-color": { r: 255, g: 73, b: 124, a: 0.2 },
    padding: "5px 20px",
    p1: "5px",
    p2: "20px",
    "border-radius": "15px",
    "margin-bottom": "15px",
  },
  ".downloadbox-section .section-title-area .section-title": {
    "font-size": "44px",
    "font-weight": "600",
    color: { r: 0, g: 0, b: 0, a: 100 },
  },
  ".downloadbox-section .downloadbox": {
    "background-color": { r: 255, g: 255, b: 255, a: 100 },
    padding: "40px 40px",
    p1: "40px",
    p2: "40px",
    "border-radius": "15px",
    border: "1px solid rgba(249, 249, 249, 1)",
    borderPx: "1px",
    borderThik: "solid",
    borderColor: { r: 249, g: 249, b: 249, a: 100 },
    "border-top": "3px solid rgb(255 73 124 / 100)",
    borderTPx: "3px",
    borderTThik: "solid",
    borderTColor: { r: 255, g: 73, b: 124, a: 100 },
    "box-shadow": "5px 5px 15px rgba(0,0,0,0.09)",
    bs1: "5px",
    bs2: "5px",
    bs3: "15px",
    shedowColor: { r: 0, g: 0, b: 0, a: 0.09 },
  },
  ".downloadbox-section .downloadbox .form-control": {
    width: "100%",
    "margin-bottom": "10px",
    "background-color": { r: 238, g: 238, b: 238, a: 100 },
    border: "2px solid rgba(238, 238, 238, 1)",
    borderPx: "2px",
    borderThik: "solid",
    borderColor: { r: 238, g: 238, b: 238, a: 100 },
    "border-radius": "0",
    "font-size": "16px",
    appearance: "auto",
    outline: "none",
  },
  ".downloadbox-section .downloadbox .btn": {
    color: { r: 255, g: 255, b: 255, a: 100 },
    "background-color": { r: 255, g: 73, b: 124, a: 100 },
  },
  custom: "",
};
